import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { TeaserBoxMediaData } from '../teaser-boxes-media.component'
import { TextInput } from '../../../types'
import { CmsConverterService, defaultTextInput } from '../../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class TeaserBoxVideoConverter extends CmsConverterService<TeaserBoxVideoData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      videoId: formData.st_video ?? '',
      teaserBoxData: {
        description: formData.st_description ?? defaultTextInput,
        headline: formData.st_headline ?? defaultTextInput,
        label: formData.st_label ?? defaultTextInput,
        sticker: formData?.st_highlighting?.value?.identifier ?? '',
        backgroundColor: 'bg-' + (formData?.st_backgroundcolor?.value?.identifier ?? 'grey'),
        promotionTracking: formData.st_promotion_tracking?.value?.identifier ?? false
      },
      descriptionOverlay: formData.st_description_text_overlay ?? defaultTextInput,
      captionOverlay: formData.st_caption_text_overlay ?? defaultTextInput,
      headlineEmpty: formData.st_headline_empty?.value ?? false,
      descriptionEmpty: formData.st_description_empty?.value ?? false
    }
  }
}

export const TEASER_BOX_VIDEO_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, CmsComponent>>('TeaserBoxVideoConverter')

export interface TeaserBoxVideoData extends TeaserBoxMediaData {
  videoId: string;
  captionOverlay: TextInput;
  descriptionOverlay: TextInput;
  headlineEmpty: boolean;
  descriptionEmpty: boolean;
}
